<template>
  <v-container
    fluid
    class="pa-7">
    <HeaderComponent
      class="pb-4"
      :title="$vuetify.lang.t('$vuetify.files.title')" />

    <v-row class="pt-5">
      <v-col
        cols="lg-8"
        offsetLg="2">
        <v-progress-circular
          v-if="status === REQUEST_STATUS.LOADING"
          indeterminate
          color="primary"
          class="ma-6" />
        <v-data-table
          v-else-if="files && files.length"
          ref="filesTable"
          :headers="filesTableHeaders"
          :items="files"
          :loading="filesLoading"
          :itemsPerPage="15"
          :elevation="0">
          <template v-slot:item.date="{ item }">
            {{ new Date(item.createdAt).toLocaleDateString() }}
          </template>
          <template v-slot:item.userName="{ item }">
            {{ getUserName(item) }}
          </template>
          <template v-slot:item.status="{ item }">
            {{ $vuetify.lang.t(`$vuetify.files.${item.status}`) }}
          </template>
          <template v-slot:item.detail="{ item }">
            <v-btn
              v-if="item.status === FILE_STATUS.PROCESSED"
              text
              @click="showDetail(item.id)">
              <v-icon>
                $vuetify.icons.detail
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import REQUEST_STATUS from '../../common/enums/requestStatus';
import FILE_STATUS from '../../common/enums/fileStatus';
import HeaderComponent from "@/components/layout/HeaderComponent.vue";

export default {
  name: "FilesHistory",

  components: {HeaderComponent},

  data() {
    return {
      REQUEST_STATUS,
      FILE_STATUS,
      filesTableHeaders: [
        {
          text: this.$vuetify.lang.t('$vuetify.labels.fileName'),
          align: 'left',
          value: 'name',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.labels.ecoChallengeFileOrdersCount'),
          align: 'left',
          value: 'ecoChallengeFileOrdersCount',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.labels.date'),
          align: 'left',
          value: 'date',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.labels.userName'),
          align: 'left',
          value: 'userName',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.labels.status'),
          align: 'left',
          value: 'status',
        },
        {
          value: 'detail',
          sortable: false,
        },
      ],
      filesLoading: false,
    }
  },

  computed: {
    ...mapGetters({
      files: 'files/getAllItems',
      status: 'files/getStatus',
    }),
  },

  mounted() {
    this.filesLoading = true;
    this.fetchAllItems().then(() => this.filesLoading = false);
  },

  methods: {
    ...mapActions('files', ['fetchAllItems']),

    getUserName(item) {
      const file = this.files.find(file => file.id === item.id);
      if (file && file.user) {
        return `${file.user.firstName} ${file.user.lastName}`
      }
    },

    showDetail(fileId) {
      this.$router.push({ name: 'files.detail', params: { id: fileId } });
    },
  },
}
</script>
